import { render, staticRenderFns } from "./Fence.vue?vue&type=template&id=2d234bda&scoped=true&"
import script from "./Fence.vue?vue&type=script&lang=js&"
export * from "./Fence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d234bda",
  null
  
)

export default component.exports